import moment from 'moment';

export const toFormatDate = (stringDate: string, momentFormat = 'DD/MM/YYYY  HH:mm:ss') => {
    let date = moment(stringDate);
    return date.format(momentFormat);
};

export const toShortFormatDate = (stringDate: string, momentFormat = 'DD/MM/YYYY') => {
    let date = moment(stringDate);
    return date.format(momentFormat);
};

export const mapDateData = (datas: any) => {
    let groups: any = {};
    datas.forEach((item: any) => {
        let dateModel: any = moment(item.data.publishedAt).format('MMMM  DD');
        let isArray = Array.isArray(groups[dateModel]);
        if (!isArray) {
            groups[dateModel] = [item];
        } else {
            groups[dateModel] = [...groups[dateModel], item];
        }
    });
    return groups;
};

export const getNow = (format = 'DD/MM/YYYY h:mm:ss') => {
    return moment(new Date(), format);
};

export const getDateTimeLocalToString = () => {
    return moment().format('YYYY-MM-DDTHH:mm').toString();
};

export const isTodayBeforeDate = (date: string, format: string = 'DD/MM/YYYY HH:MM') => {
    if (!date) return false;

    const givenDate = moment(date, format);
    const today = moment();

    return today.isBefore(givenDate);
};
